import { useTranslation } from 'next-i18next'
import { Button } from 'components/Button'
import { LocalizationToggle } from 'components/LocalizationToggle'
import type { Localization } from '@captaincause/types'

interface NavCallToActionsProps {
  localizations: Localization[]
}

export function NavCallToActions({ localizations }: NavCallToActionsProps) {
  const { t } = useTranslation('nav.component')

  return (
    <>
      <Button
        variant="secondary"
        href="/particuliers"
        className="w-full bg-purple text-sm text-black md:w-[revert]"
        locale={false}
        noWrap
        small
      >
        {t('cta.c2c')}
      </Button>
      <Button
        variant="secondary"
        href="https://app.dift.com"
        className="w-full text-sm md:w-[revert]"
        noWrap
        small
      >
        {t('cta.login')}
      </Button>
      <Button
        variant="secondary"
        href="/contact"
        className="w-full text-sm md:w-[revert]"
        noWrap
        small
      >
        {t('cta.contact')}
      </Button>
      <LocalizationToggle localizations={localizations} />
    </>
  )
}
